import { render } from "./HvvDepartures.vue?vue&type=template&id=130a4489"
import script from "./HvvDepartures.vue?vue&type=script&lang=js"
export * from "./HvvDepartures.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__